var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Reports_ACtive"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reports_ACtive",
    clipPath: "url(#clip-Reports_ACtive)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reports",
    transform: "translate(3 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_48",
    "data-name": "Subtraction 48",
    d: "M-1471.774-576.808h-13.715A2.524,2.524,0,0,1-1488-579.34v-20.129a2.524,2.524,0,0,1,2.511-2.532h3.36v1.189a.781.781,0,0,0,.779.78h8.455a.781.781,0,0,0,.78-.78V-602h3.246a2.524,2.524,0,0,1,2.511,2.532v7.194a.574.574,0,0,1-.571.576v.869a.572.572,0,0,1,.571.571v.3a.571.571,0,0,1-.571.571v.957a.574.574,0,0,1,.571.575v2.786a5.343,5.343,0,0,0-1.085-.111,5.314,5.314,0,0,0-5.307,5.308,5.273,5.273,0,0,0,.974,3.065Zm-11.861-7.546a.571.571,0,0,0-.571.571.571.571,0,0,0,.571.571h6.063a.571.571,0,0,0,.571-.571.571.571,0,0,0-.571-.571Zm.014-3.852a.571.571,0,0,0-.571.571.571.571,0,0,0,.571.571h8.817a.571.571,0,0,0,.571-.571.571.571,0,0,0-.571-.571Zm0-3.852a.571.571,0,0,0-.571.571.571.571,0,0,0,.571.571h12.884a.571.571,0,0,0,.571-.571.571.571,0,0,0-.571-.571Zm0-3.866a.571.571,0,0,0-.571.571.571.571,0,0,0,.571.571h12.884a.571.571,0,0,0,.571-.571.571.571,0,0,0-.571-.571Z",
    transform: "translate(1488 603.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2174",
    "data-name": "Group 2174",
    transform: "translate(5.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4763",
    "data-name": "Path 4763",
    d: "M19.644,10.1H12.467a2,2,0,0,1-2-2V7.557a2,2,0,0,1,2-2h7.176a2,2,0,0,1,2,2V8.1A2,2,0,0,1,19.644,10.1ZM12.467,6.716a.843.843,0,0,0-.842.842V8.1a.843.843,0,0,0,.842.842h7.176a.843.843,0,0,0,.842-.842V7.557a.843.843,0,0,0-.842-.842H12.467Z",
    transform: "translate(-10.47 -5.56)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2172",
    "data-name": "Group 2172",
    transform: "translate(14.693 18.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4758",
    "data-name": "Path 4758",
    d: "M22.849,29.957A5.877,5.877,0,1,1,24.974,18.6a5.878,5.878,0,0,1-2.126,11.357Zm-.014-10.615a4.73,4.73,0,1,0,.014,9.459,4.719,4.719,0,0,0,4.309-6.634h0a4.757,4.757,0,0,0-4.323-2.825Z",
    transform: "translate(-16.969 -18.199)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4764",
    "data-name": "Path 4764",
    d: "M21.1,24.909a.613.613,0,0,1-.4-.157l-1.27-1.2a.575.575,0,1,1,.785-.842l.856.8,2.24-2.4a.575.575,0,1,1,.842.785l-2.639,2.811a.585.585,0,0,1-.4.185H21.1Z",
    transform: "translate(-1.301 1.21)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsActive);
export default __webpack_public_path__ + "static/media/Reports_Active.fc51677b0f2530b14b4d9220dc497351.svg";
export { ForwardRef as ReactComponent };